import { PaymentDetailsGeneralType } from '@/types/paymentDetailsTypes';
import { authApiService } from '@/api/authApiService';
import { ApiResponseType } from '@/types/sharedTypes';

export const getDepositAccountPaymentDetailsApi = (id: string): Promise<ApiResponseType<PaymentDetailsGeneralType>> => {
  const uri = `/organization/deposit-accounts/${id}/payment-details/`;

  return authApiService.GET(uri);
};
